module.exports = ".logo {\n  max-height: 70px;\n  max-width: 100px;\n  width: auto;\n  height: auto; }\n\ntable tr td {\n  line-height: 45px; }\n"